<div id="join-us" class="join-us bg-light">
    <div class="container">
        <div class="row mt-3">
            <div class="col-12">
                <h1 class="fw-bold title ps-3 display-5">Join Us !</h1>
            </div>
        </div>
        <div class="row mt-4 align-items-center justify-content-between">
            <div class="col-12 mb-4 col-md-6">
                <img class="img-fluid shadow" src="assets/img/P2360081.JPG">
            </div>
            <div class="col-12 mb-4 col-md-5">
                <p class="fs-3">
                    We are actively recruiting self-motivated Master's and PhD students, postdoctoral researchers, and research interns with a strong background in plant phenotyping, agricultural robotics, machine learning, and AI in agriculture. If interested, please send an email with the subject line: 'Prospective [Position] – [Your Name]'.
                </p>
                <!-- <p class="my-0 mt-4 text-secondary fs-5">
                    Please read the pdf file below for detailed information.
                </p> -->
                <!-- <div class="mt-4">
                    <a class="lead border-bottom border-2 border-primary pb-1"
                        href="https://shangpenglab.s3.us-east-2.amazonaws.com/PhD_Master+openings+at+McGill+University.pdf"
                        target="_blank">
                        <i class="bi bi-cloud-arrow-down-fill me-2 text-danger"></i>
                        PhD & MSC openings for Fall 2023.pdf
                    </a>
                </div> -->
                <!-- <div class="mt-4">
                    <a class="lead border-bottom border-2 border-primary pb-1"
                        href="https://shangpenglab.s3.us-east-2.amazonaws.com/Postdoctoral+Researcher+Recruitment_2023.pdf"
                        target="_blank">
                        <i class="bi bi-cloud-arrow-down-fill me-2 text-danger"></i>
                        Postdoctoral researcher recruitment.pdf
                    </a>
                </div> -->
            </div>
        </div>
    </div>
</div>